import {
  defaultProviderListFilter,
  providerListColumnVisibilityOptions,
  defaultProviderListColumnVisibility,
} from '@utils/tables/providers/providerListFilter';

// System
import { createSlice } from '@reduxjs/toolkit';

// Type
const initialState = {
  selectedFilters: defaultProviderListFilter,
  columnVisibility: defaultProviderListColumnVisibility,
  columnVisibilityOptions: providerListColumnVisibilityOptions,
  providersTableFilters: {},
};

const providerTableSlice = createSlice({
  name: 'providerTable',
  initialState,
  reducers: {
    setColumnVisibility: (state, { payload }) => {
      state.columnVisibility = payload;
    },
    // setProvidersTableFilters: (state, { payload }) => {
    //   const { codeName, value } = payload;
    //   const { providersTableFilters } = state;
    //   const convertedValue = typeof value !== 'object' || value === null ? value : value[0];

    //   const newProvidersTableFilters = {
    //     ...providersTableFilters,
    //     [codeName]:
    //       convertedValue === 'true' ? true : convertedValue === 'false' ? false : convertedValue,
    //   };
    //   state.providersTableFilters = newProvidersTableFilters;
    // },
    setProvidersTableFilters: (state, { payload }) => {
      const { codeName, value } = payload;
      const { providersTableFilters } = state;
      const convertedValue = typeof value !== 'object' || value === null ? value : value[0];

      let finalValue: typeof convertedValue;

      if (codeName === 'gameId') {
        finalValue = Number(convertedValue);
      } else {
        finalValue =
          convertedValue === 'true' ? true : convertedValue === 'false' ? false : convertedValue;
      }

      state.providersTableFilters = {
        ...providersTableFilters,
        [codeName]: finalValue,
      };
    },
    setClearProvidersTableFilters: (state) => {
      state.providersTableFilters = {};
    },
  },
  extraReducers: {},
});

export const { reducer: providerTableReducer } = providerTableSlice;
export const { setColumnVisibility, setProvidersTableFilters, setClearProvidersTableFilters } =
  providerTableSlice.actions;
